import {
  DECORATIVE_APPROVAL_ORDER_FAILED,
  DECORATIVE_APPROVAL_ORDER_SUCCESS,
  DECORATIVE_APPROVAL_ORDER_REQUEST,
} from "app/redux/actions/Order/DecorativeApprovalOrder/constant";

const INIT_STATE = {
  loading: false,
  totalPage: 0,
  data: [],
  error: {
    isError: false,
    message: null,
  },
};

export const decorativeApprovalOrderReducer = function (state = INIT_STATE, action) {
  switch (action?.type) {
    case DECORATIVE_APPROVAL_ORDER_REQUEST:
      return {
        loading: true,
        totalPage: 0,
        data: [],
        error: {
          isError: false,
          message: null,
        },
      };
    case DECORATIVE_APPROVAL_ORDER_SUCCESS:
      return {
        loading: false,
        data: action?.payload?.data,
        totalPage: action?.payload?.totalPage,
        error: {
          isError: false,
          message: null,
        },
      };
    case DECORATIVE_APPROVAL_ORDER_FAILED:
      const { isError = true, message = "Something Went Wrong" } =
        action?.payload?.error || {};
      return {
        loading: false,
        totalPage: 0,
        data: [],
        error: {
          isError: isError,
          message: message,
        },
      };
    default:
      return state;
  }
};
